import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";

import {
    REQUEST_AGENT_CREATE,
    REQUEST_AGENT_DELETE,
    REQUEST_AGENT_ENABLE,
    REQUEST_AGENT_LIST,
    REQUEST_AGENT_TEST,
    REQUEST_AGENT_UPDATE,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/eisenhower/eisenhowerMsgs";
import { CrudModel, EdgeServerID } from "userful-chronos-app-common-js/dist/models/eisenhower/edgeSetup";
import "./modelMsgReciever";
import { StringID } from "userful-chronos-app-common-js/dist/models/common";
import { AgentHeader } from "userful-chronos-app-common-js/dist/models/eisenhower/agent/agents";
import "./agentMsgReciever";

export const requestListAgents = () => {
    getGlobalStates().eventBus.sendMsg(REQUEST_AGENT_LIST);
};

export const requestAddAgents = (payload: AgentHeader) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_AGENT_CREATE, payload);
};

export const requestUpdateAgents = (payload: AgentHeader) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_AGENT_UPDATE, payload);
};

export const requestRemoveAgents = (payload: StringID) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_AGENT_DELETE, payload);
};

export const requestEnableAgents = (payload: { id: StringID; enabled: boolean }) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_AGENT_ENABLE, payload);
};

export const requestTestAgent = (payload: StringID) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_AGENT_TEST, payload);
};
